<div class="divMessage">
<h1 mat-dialog-title class="h1Send"
>{{data.message}}</h1>
</div>
<div mat-dialog-content >

  <ul>
    
    <li>
        <p><b>Esito:</b><br>
      <span *ngIf="data.result">&emsp;{{data.result | translate}}</span> 
        </p>
    </li>
    </ul>
  
</div>
<div mat-dialog-actions>

<mat-dialog-actions align="end">
    <!--<button mat-button mat-dialog-close (click)="onReturn()" class="btn btn-primary-outline">Ritorna</button>-->
    <button mat-raised-button color="primary" (click)="onReturn()" >OK</button>
  </mat-dialog-actions>

</div>